import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './context/AuthContext'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import Tenants from './pages/Tenants'
import TenantDetail from './pages/TenantDetail'
import Layout from './components/Layout'

function ProtectedRoute ({ children }: { children: React.ReactNode }) {
  const token = localStorage.getItem('inv_admin_token')
  if (!token) return <Navigate to="/login" replace />
  return <>{children}</>
}

export default function App () {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<ProtectedRoute><Layout><Dashboard /></Layout></ProtectedRoute>} />
          <Route path="/empresas" element={<ProtectedRoute><Layout><Tenants /></Layout></ProtectedRoute>} />
          <Route path="/empresas/:id" element={<ProtectedRoute><Layout><TenantDetail /></Layout></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  )
}
